import { render } from "./MobilePlanetaryPositionsPanchanga.vue?vue&type=template&id=7f595dd2&scoped=true"
import script from "./MobilePlanetaryPositionsPanchanga.vue?vue&type=script&lang=js"
export * from "./MobilePlanetaryPositionsPanchanga.vue?vue&type=script&lang=js"

import "./MobilePlanetaryPositionsPanchanga.vue?vue&type=style&index=0&id=7f595dd2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f595dd2"]])

export default __exports__